var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            value: _vm.dialog,
            fullscreen: "",
            transition: "dialog-bottom-transition",
          },
          on: {
            "click:outside": function ($event) {
              return _vm.closeDialog()
            },
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              )
                return null
              return _vm.closeDialog()
            },
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.importar.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v(_vm._s(_vm.modal_title)),
                    ]),
                  ]),
                  _c(
                    "v-card-text",
                    { staticStyle: { "margin-bottom": "120px" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "mb-4 mt-4",
                          attrs: { align: "center", justify: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-0", attrs: { md: "10" } },
                            [
                              _c(
                                "v-stepper",
                                { attrs: { value: _vm.step + 1 } },
                                [
                                  _c(
                                    "v-stepper-header",
                                    [
                                      _c(
                                        "v-stepper-step",
                                        {
                                          attrs: {
                                            complete: _vm.step > 0,
                                            step: "1",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.steps[0]))]
                                      ),
                                      _c("v-divider"),
                                      _c(
                                        "v-stepper-step",
                                        { attrs: { step: "2" } },
                                        [_vm._v(_vm._s(_vm.steps[1]))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.step == 0
                        ? _c(
                            "v-row",
                            { attrs: { align: "start", justify: "center" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "mt-4 text-center",
                                  attrs: { cols: "12", md: "6" },
                                },
                                [
                                  _c("p", { staticClass: "fs-16 mb-2" }, [
                                    _c("b", [_vm._v(_vm._s(_vm.steps[0]))]),
                                  ]),
                                  _c("v-label", [
                                    _vm._v(
                                      " Descargar la plantilla de importación de legajos. "
                                    ),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "font-weight-bold ml-1",
                                        on: { click: _vm.downloadExcel },
                                      },
                                      [_vm._v("Descargar")]
                                    ),
                                  ]),
                                  _c("v-file-input", {
                                    staticClass: "mt-3",
                                    attrs: {
                                      accept: ".xlsx",
                                      label: "Seleccionar excel",
                                      hint: "Solo admite archivos formato .xlsx (No admite formato .xls)",
                                      "persistent-hint": "",
                                    },
                                    model: {
                                      value: _vm.excelFile,
                                      callback: function ($$v) {
                                        _vm.excelFile = $$v
                                      },
                                      expression: "excelFile",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.step == 1
                        ? _c(
                            "v-row",
                            { attrs: { align: "start", justify: "center" } },
                            [
                              _c(
                                "v-col",
                                { staticClass: "mt-4", attrs: { md: "10" } },
                                [
                                  _c("p", { staticClass: "fs-16 mb-2" }, [
                                    _c("b", [_vm._v(_vm._s(_vm.steps[1]))]),
                                  ]),
                                  _c(
                                    "v-progress-linear",
                                    {
                                      staticClass: "mb-3 mt-3",
                                      attrs: {
                                        value: _vm.percent,
                                        color: "blue-grey",
                                        height: "25",
                                      },
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(Math.ceil(_vm.percent) || 0) +
                                            "%"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("v-data-table", {
                                    attrs: {
                                      headers: _vm.headers,
                                      items: _vm.list_bulk,
                                      loading: _vm.loading_table,
                                      "loading-text": "Cargando...",
                                      "items-per-page": 10,
                                      dense: "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item",
                                          fn: function ({ item }) {
                                            return [
                                              _c("tr", [
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.object.nro_legajo ||
                                                        "Auto"
                                                    )
                                                  ),
                                                ]),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(item.object.name)
                                                  ),
                                                ]),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(item.object.surname)
                                                  ),
                                                ]),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.object
                                                        .document_type_name
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        item.object.document
                                                      )
                                                  ),
                                                ]),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.object.sucursal_name
                                                    )
                                                  ),
                                                ]),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.object
                                                        .worksector_name
                                                    )
                                                  ),
                                                ]),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.object
                                                        .workstation_name
                                                    )
                                                  ),
                                                ]),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.object.hire_date
                                                    )
                                                  ),
                                                ]),
                                                _c(
                                                  "td",
                                                  {
                                                    staticStyle: {
                                                      "min-width": "200px",
                                                    },
                                                  },
                                                  [
                                                    item.loading
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "Procesando..."
                                                          ),
                                                        ])
                                                      : item.status == 0
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "Pendiente de procesado"
                                                          ),
                                                        ])
                                                      : item.status_create
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "green--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Importado "
                                                            ),
                                                            item.access_msg
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    class:
                                                                      item.access_status
                                                                        ? "grey--text"
                                                                        : "orange--text text--darken-3",
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "11px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.access_msg
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "red--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.msg)
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1320522528
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    {
                      staticClass: "pa-0",
                      staticStyle: {
                        position: "fixed",
                        bottom: "0",
                        right: "0",
                        left: "0",
                      },
                    },
                    [
                      _c(
                        "v-row",
                        {
                          attrs: {
                            align: "start",
                            justify: "center",
                            "no-gutters": "",
                          },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "py-3",
                              staticStyle: { "background-color": "white" },
                              attrs: { cols: "10" },
                            },
                            [
                              _vm.step > 0
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "blue-grey",
                                        outlined: "",
                                        disabled: _vm.loading_create,
                                      },
                                      on: { click: _vm.prev },
                                    },
                                    [_vm._v("Atras")]
                                  )
                                : _vm._e(),
                              _vm.step == 1
                                ? _c(
                                    "div",
                                    { staticClass: "float-right mr-2" },
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { color: "success" },
                                        },
                                        [
                                          _vm._v(
                                            "Importados: " +
                                              _vm._s(_vm.importaciones_creadas)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-chip",
                                        { attrs: { color: "error" } },
                                        [
                                          _vm._v(
                                            "Fallidos: " +
                                              _vm._s(
                                                _vm.importaciones_no_creadas
                                              )
                                          ),
                                        ]
                                      ),
                                      _vm.importaciones_no_creadas > 0
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "ml-3",
                                              attrs: {
                                                color: "error",
                                                outlined: "",
                                                small: "",
                                              },
                                              on: {
                                                click: _vm.downloadErrorsExcel,
                                              },
                                            },
                                            [_vm._v("Descargar Errores")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.step == 0
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "float-right",
                                      attrs: {
                                        outlined: "",
                                        color: "primary",
                                        disabled: _vm.excelFile == null,
                                      },
                                      on: { click: _vm.readExcel },
                                    },
                                    [_vm._v("Siguiente")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "text-right pa-2",
                              staticStyle: {
                                "background-color": "#fafafa",
                                "border-top": "1px solid #c1c1c1",
                              },
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "error",
                                    text: "",
                                    disabled: _vm.loading_create,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.closeDialog()
                                    },
                                  },
                                },
                                [_vm._v("Cerrar")]
                              ),
                              _vm.step == 1
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "success",
                                        text: "",
                                        type: "submit",
                                        disabled:
                                          _vm.submit_disabled ||
                                          _vm.list_bulk.length == 0,
                                        loading: _vm.loading_create,
                                      },
                                    },
                                    [_vm._v("Importar")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }